export default {
  title: 'Boekingsbeschikbaarheden',
};
